import * as types from "./ActionTypes";
import Api from "../api/OrganizationApi";

export const selectOrganization = (organization) => {
    return { type: types.SELECT_ORGANIZATION, organization };
};

export const clearOrganizations = () => {
    return { type: types.GET_ORGANIZATIONS_BY_VALUE_SUCCEEDED, organizations: []};
};

export const searchByNameOrSite = (value) => {
    return (dispatch) => {
        return Api.searchByNameOrSite(value)
            .then((organizations) => {
                dispatch({ type: types.GET_ORGANIZATIONS_BY_VALUE_SUCCEEDED, organizations });
            })
            .catch((error) => {
                dispatch({ type: types.GET_ORGANIZATIONS_BY_VALUE_FAILED, error });
                throw(error);
            });
    };
};

export const loadSsoSettingsForSiteId = (siteId) => {
    return (dispatch) => {
        return Api.loadSsoSettingsForSiteId(siteId)
            .then((response) => {
                dispatch({ type: types.GET_ORGANIZATION_SSO_SETTINGS_BY_SITE_SUCCEEDED, settings: response });
            })
            .catch((error) => {
                dispatch({ type: types.GET_ORGANIZATION_SSO_SETTINGS_BY_SITE_FAILED, error });
            });
    };
};

export const loadSsoSettingsById = (id) => {
    return (dispatch) => {
        return Api.loadSsoSettingsById(id)
            .then((response) => {
                dispatch({ type: types.GET_ORGANIZATION_SSO_SETTINGS_BY_ID_SUCCEEDED, settings: response });
            })
            .catch((error) => {
                dispatch({ type: types.GET_ORGANIZATION_SSO_SETTINGS_BY_ID_FAILED, error });
            });
    };
};

export const loadSettingsById = (id) => {
    return (dispatch) => {
        return Api.loadSettingsById(id)
            .then((response) => {
                dispatch({ type: types.GET_ORGANIZATION_SETTINGS_BY_ID_SUCCEEDED, settings: response });
            })
            .catch((error) => {
                dispatch({ type: types.GET_ORGANIZATION_SETTINGS_BY_ID_FAILED, error });
                //throw(error);
            });
    };
};

export const loadPasswordSettingsById = (id) => {
    return (dispatch) => {
        return Api.loadPasswordSettingsById(id)
            .then((response) => {
                dispatch({ type: types.GET_ORGANIZATION_PASSWORD_SETTINGS_BY_ID_SUCCEEDED, settings: response });
            })
            .catch((error) => {
                dispatch({ type: types.GET_ORGANIZATION_PASSWORD_SETTINGS_BY_ID_FAILED, error });
                throw(error);
            });
    };
};

export const getOrganizationById = (id) => {
    return (dispatch) => {
        return Api.getOrganizationById(id)
            .then((organization) => {
                dispatch({ type: types.GET_ORGANIZATION_BY_ID_SUCCEEDED, organization: organization });
                return organization;
            })
            .catch((error) => {
                dispatch({ type: types.GET_ORGANIZATION_BY_ID_FAILED, error });
                throw(error);
            });
    };
};

export const getPasswordSettingsByTicket = (ticket) => {
    return (dispatch) => {
        return Api.loadSettingsByTicket(ticket)
            .then((response) => {
                dispatch({ type: types.GET_ORGANIZATION_SETTINGS_BY_TICKET_SUCCEEDED, settings: response });
                return response;
            })
            .catch((error) => {
                dispatch({ type: types.GET_ORGANIZATION_SETTINGS_BY_TICKET_FAILED, error });
                throw(error);
            });
    };
};

